import service from './baseService';

export const getRoomTypesService = () => {
    return service.get('/room-types');
};
